import { ValidationObserver, ValidationProvider } from "vee-validate";
import firebase from "firebase";
import { PremiumServiceEventTypeEnum, PremiumServiceProductTypeEnum, PremiumServiceRequestTypeEnum } from "@/enums/PremiumServiceEventTypes";

export default {
  name: "RejectRequestDialog",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      dialog: false,
      request: null,
      approvals: null,
      rejectServiceRequestForm: {
        rejectReason: null,
        rejectComment: null
      },
      rejectReasons: [
        "Not compliant with care plan",
        "Duplicate request",
        "Resident changed their mind",
        "Other"
      ]
    }
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
  },
  methods: {
    open(request, approvals) {
      this.dialog = true;
      this.request = request;
      this.approvals = approvals;
    },
    close() {
      this.dialog = false;
      this.rejectServiceRequestForm.rejectReason = null;
      this.rejectServiceRequestForm.rejectComment = null;
    },
    async rejectServiceRequest() {
      const id = this.request.id;
      const rejectReason = this.rejectServiceRequestForm.rejectReason;
      const rejectComment = this.rejectServiceRequestForm.rejectComment;

      const approvalService = this.approvals[0];

      const payload = {
        id,
        rejectReason,
        approvalService,
        rejectComment
      };

      await this.$store.dispatch("rejectAdditionalServiceRequest", payload);

      let title, body = ``

      const eventTypes = Object.values(PremiumServiceEventTypeEnum)
      const requestTypes = Object.values(PremiumServiceRequestTypeEnum)
      const productTypes = Object.values(PremiumServiceProductTypeEnum)

      if(eventTypes.includes(this.request.serviceItemType) || requestTypes.includes(this.request.serviceItemType)){
        title = `The ${this.request.serviceName} booking for ${this.request.residentName} in ${this.facility.name} was rejected`
        body = `The <b>${this.request.serviceName}</b> booking for <b>${this.request.residentName}</b> in <b>${this.facility.name}</b> was rejected. A refund might be needed. 
        Click <a href="https://${this.$store.state.facilityModule.selectedFacility.baseUrl}/bookings-and-orders/${this.request.id}">here</a> to view the booking.`
      }

      else if (productTypes.includes(this.request.serviceItemType)){
        title = `The ${this.request.serviceName} order for ${this.request.residentName} in ${this.facility.name} was rejected`
        body = `The <b>${this.request.serviceName}</b> order for <b>${this.request.residentName}</b> in <b>${this.facility.name}</b> was rejected. A refund might be needed. 
        Click <a href="https://${this.$store.state.facilityModule.selectedFacility.baseUrl}/bookings-and-orders/${this.request.id}">here</a> to view the order.`
      }

      await firebase
        .firestore()
        .collection('email')
        .add({
          to: "support@getreshub.com",
          facilityId: this.facility.id,
          message: {
            subject: title,
            html: body
          }
        })

      await this.$store.dispatch("deleteAppointmentEventsByRequest", this.request);
      this.close();
    }
  }
}